// extracted by mini-css-extract-plugin
export default {"root":"app-bar_root__ouWwZ","content":"app-bar_content__d84Sa","placeHolderShimmer":"app-bar_placeHolderShimmer__oidwE"};